import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function CheckoutCancelPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-gradient-to-br from-forfy-50 via-white to-neutral-50">
      <div className="w-full max-w-md rounded-2xl shadow-xl border border-neutral-100 bg-white p-8 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-neutral-100 mb-4">
          <XCircle className="w-7 h-7 text-neutral-400" />
        </div>
        <h1 className="text-2xl font-display font-semibold text-neutral-900">Pagamento annullato</h1>
        <p className="mt-2 text-sm text-neutral-500">
          Nessun addebito è stato effettuato. Puoi passare a Pro quando vuoi.
        </p>
        <div className="mt-6 flex flex-col gap-2 items-center">
          <Link to="/checkout" className="w-full max-w-xs px-4 py-2.5 rounded-lg font-medium text-sm bg-forfy-600 text-white hover:bg-forfy-700 transition-colors">
            Riprova
          </Link>
          <Link to="/dashboard" className="inline-flex items-center gap-1.5 mt-1 text-sm text-neutral-500 hover:text-neutral-700">
            <ArrowLeft className="w-4 h-4" /> Torna alla dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
